// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Lingui from "../../locales/Lingui.re.mjs";
import * as HomePage from "../pages/HomePage.re.mjs";
import * as RelayEnv from "../../entry/RelayEnv.re.mjs";
import * as Localized from "../shared/i18n/Localized.re.mjs";
import * as ReactRouterDom from "react-router-dom";
import * as HomePageQuery_graphql from "../../__generated__/HomePageQuery_graphql.re.mjs";

let LoaderArgs = {};

let loadMessages = Lingui.loadMessages({
  en: import("../../locales/src/components/pages/HomePage.re/en"),
  ja: import("../../locales/src/components/pages/HomePage.re/ja")
});

async function loader(param) {
  let query = HomePageQuery_graphql.load(RelayEnv.getRelayEnv(param.context, import.meta.env.SSR), undefined, "store-or-network", undefined, undefined);
  return ReactRouterDom.defer({
    data: query,
    i18nLoaders: Localized.loadMessages(param.params.lang, loadMessages)
  });
}

let component = HomePage.make;

export {
  component,
  LoaderArgs,
  loadMessages,
  loader,
}
/* loadMessages Not a pure module */
